import React from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';

export const MarkdownHeading = ({ ...props }) => {
  const { node, children: _children, ...elementProps } = props;

  let [text, anchor] = ['', ''];
  if (node.children?.[0]?.value?.includes?.('_anchor_')) {
    [text, anchor] = node.children[0].value.split('_anchor_');
  } else {
    text = node.children[0].value;
    anchor = '';
  }

  const headingClassName = clsx({
    [styles.heading_h1]: node.tagName === 'h1',
    [styles.heading_h2]: node.tagName === 'h2',
    [styles.heading_h3]: node.tagName === 'h3',
  });

  return React.createElement(
    node.tagName,
    {
      ...elementProps,
      className: headingClassName,
      id: anchor,
    },
    text
  );
};
